import React, { useRef } from 'react';

// import Satellite1Jpg from 'src/pages/Mockup/assets/jpg/satellite-world-bg.jpg';
// import Satellite2Jpg from 'src/pages/Mockup/assets/jpg/yellow-blue-satellite-world-bg.jpg';
// import { ReactComponent as Satellite3Svg } from 'src/pages/Mockup/assets/svg/satellite-silhouette.svg';
// import { ReactComponent as Satellite4Svg } from 'src/pages/Mockup/assets/svg/simple-satellite-icon.svg';
// import { ReactComponent as RocketshipSvg } from 'src/pages/Mockup/assets/svg/rocketship-drawing.svg';
// import SpaceJpg from 'src/pages/Mockup/assets/jpg/space-diagonal-axis.jpg';

import { Parallax, ParallaxBanner } from 'react-scroll-parallax';
// import { Parallax, ParallaxLayer } from '@react-spring/parallax';

import Grid from '@mui/material/Grid';
import { Translate } from '@mui/icons-material';

// TODO: need to find out why the back button isn't appearing on this page
function InitialBeginnerParallax() {
  const ref = useRef(null);
  return (
    <div
      style={{
        // set size of div
        height: '50vh',
        width: '100vw',

        // set how far div is from the container borders
        margin: '1500px 0 1500px 0',

        // for centering the div
        position: 'relative',
        inset: '50% 50%',
        transform: 'translate(-50%, -50%)',

        // for centering the items in the div
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <ParallaxBanner
        layers={[
          // when scrolling down,
          // negative speed causes layer to go down as you scroll down
          // positive speed causes layer to go up out of screen as you scroll down

          // {image: `${Satellite1Jpg}`, speed: -20},
          // {image: `${Satellite2Jpg}`, speed: -5},
          {
            // if you look in elements, you can see it's there, it's just way off above the screen
            // also if you give the parallax banner a top of: "500px", it shows up but cropped.
            // also if you look at the App div that is a parent of this banner, it shows up all the way at the top?? and it's only like 100px in height
            // changed the parallax banner to heeight 700px and that also changed the parent App and root div's to have 700px in height
            // there's something wront bc when I put height: "500px" and top: "700px" for the banner, the h1 shows up but when I scroll down, it hides behind the banner?? wasn't it supposed to be in the banner?

            // okay I think I found the problem
            // the app changing to be "700px" when I change parallax banner to "700px" is fine
            // since the position of the parallax banner consists of two divs: one that is relative and an inner one that is absolute (these are needed for parallax as seen by other tutorials). the outer container is the "page" the inner container is the one that moves as one scrolls
            // when I start to scroll down, the banner disappears as it should because the inner container starts to go out of the outer container. and teh overflow for the outer container is set to hidden
            // my qualms are that when the inner container is in the outer container with the text in the inner container as well, that we can't see the text
            // I think that there is a layer that has a z axis greater than the parallax banner outer div container and it's covering the parallax banner. that's why I can't see the banner text unless I set the position of the parallax banner to an offset outside of the border of the container containing the parallax container

            // Actually, this was all my fault, I realize after looking at the demo again, that it was supposed to start off screen. then it was supposed to scroll on screen as I scrolled down
            translateY: [0, 100], // starts at top of banner then scrolls off!!
            speed: -10,
            children: (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <h1
                  style={{
                    color: 'white',
                    backgroundColor: 'black',
                    fontSize: '60px',
                  }}
                >
                  Hi, welcome to my parallax site
                </h1>
              </div>
            ),
          },
        ]}
        style={{
          height: '100%',
          position: 'relative',
          backgroundColor: 'lightblue',
        }}
      ></ParallaxBanner>
    </div>
  );
}

export default InitialBeginnerParallax;


